import { Head } from '@inertiajs/react';
import ReactPlayer from "react-player";
import Layout from '@/layouts/layout';

export default function Videos({videos}) {
    const {data} = videos;
    return (
        <Layout>
            <Head title="Videos" />
            <div className='py-12 grid grid-cols-1 lg:grid-cols-2 gap-12 justify-center px-4'>
                {data.map((video, idx) => (
                    <div key={idx} className='aspect-video shadow-sm rounded-sm bg-accent p-4'>
                      <ReactPlayer
                        slot="media"
                        src={video.url}
                        light={true}
                        width='100%'
                        height='100%'
                        controls={true}
                      ></ReactPlayer>
                    </div>
                ))}
            </div>
        </Layout>
    );
}
